import { section } from "@/glow";
import { animateStandard, shouldAnimate } from "@/lib/animation";

section("contact-form", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateContactForm = animateStandard(this.container);
    }
  },

  onUnload() {
    this.animateContactForm?.destroy();
  },
});
